import { ArrowDown, ArrowUp, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TableHead } from "@/components/ui/table";
import type { SortDirection, SortKey } from "@/lib/documents/document-list";
import { cn } from "@/lib/utils/cn";

type SortableHeadProps = {
  sortKey: SortKey;
  label: string;
  sort: SortKey | undefined;
  direction: SortDirection;
  onSort: (key: SortKey) => void;
  className?: string;
  /** Right-aligned columns (amounts) put the arrow on the left of the label. */
  alignEnd?: boolean;
};

/** A column header that sorts the list by `sortKey`. */
export function SortableHead({
  sortKey,
  label,
  sort,
  direction,
  onSort,
  className,
  alignEnd,
}: SortableHeadProps) {
  const active = sort === sortKey;
  const Icon = !active ? ChevronsUpDown : direction === "asc" ? ArrowUp : ArrowDown;
  return (
    <TableHead
      className={className}
      aria-sort={active ? (direction === "asc" ? "ascending" : "descending") : undefined}
    >
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className={cn("h-8", alignEnd ? "-mr-3 flex-row-reverse" : "-ml-3")}
        onClick={() => onSort(sortKey)}
        data-testid={`sort-${sortKey}`}
      >
        {label}
        <Icon className={cn(!active && "opacity-40")} />
      </Button>
    </TableHead>
  );
}
